import { render, staticRenderFns } from "./EditLocal.vue?vue&type=template&id=18dc8900"
import script from "./EditLocal.vue?vue&type=script&lang=js"
export * from "./EditLocal.vue?vue&type=script&lang=js"
import style0 from "./EditLocal.vue?vue&type=style&index=0&id=18dc8900&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports